module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-40-26-963.80fc21f5.mp4";